import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { showNotification } from '@publicisgroupe/p-os-components';

const useErrorNotification = () => {
  const { t } = useTranslation();

  const showErrorNotification = useCallback(
    ({
      errorTitle = t('GeneralErrorMessage'),
      content = t('ContactAdministratorMessage'),
    } = {}) => {
      showNotification.error({
        title: errorTitle,
        content: content,
        inverted: true,
      });
    },
    [t]
  );

  return { showErrorNotification };
};

export default useErrorNotification;
